import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {AuthService} from '../../../../services/auth.service';
import Swal from 'sweetalert2';
import {UserService} from "../../../../services/user.service";
import {User} from "../../../../models/user.model";
import {RoleService} from "../../../../services/role.service";
import { emailValidator, passWordValidator } from '../../validators/validator';
import { Role } from '../../../../models/role.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {
  constructor(private router: Router, private roleService: RoleService, private fb: FormBuilder, private authService: AuthService, private userService: UserService) { }
  password: any;
  roleback: Role;
  show: boolean | undefined;

  get login() { return this.loginForm.controls; }

  loginForm = this.fb.group({
    email: new FormControl('',{ validators: emailValidator('e-mail'), updateOn: 'change'}),
    password: new FormControl('',{ validators: passWordValidator('Le mot de passe',8), updateOn: 'change'}),
  });

  ngOnInit(): void {
    this.password = 'text';
    this.show = false;
    this.onClickeye();
    this.loadBackOfficeRole();
  }

  onClickeye() {
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }
  onFormSubmit(): void {
    /*this.userService.verifUserEmail(this.loginForm.controls['email'].value).subscribe(
      rs => {
        if (rs != null) {

        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Email inexistant, veuillez resaisir un email valide',
            showConfirmButton: false,
            timer: 2500
          });
        }
      });*/
    this.authService.login(this.loginForm.getRawValue())
      .subscribe(rest => {
          this.authService.deleteSession();
          this.authService.getUSerByKahpooSession(rest.kapo_session_id).subscribe((value: any) => {            
            if (value.minimizedRoles.includes(this.roleback.id)) {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Connexion réussie',
                showConfirmButton: false,
                timer: 1500
              });
              this.authService.saveSession(rest);
              this.router.navigate(['/dashboard']);

            } else {
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: ' Vous n\'êtes pas autorisé à accéder au BackOffice',
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        },
        error => {
          //console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Authentication échouée : L\'adresse e-mail ou le mot de passe est invalide',
            showConfirmButton: false,
            timer: 2500
          });
        });
  }

  loadBackOfficeRole() {
    let back = false;
    this.roleService.getidRoleName("-BACK_OFFICE-").subscribe(r => {
      this.roleback =  r;
      //console.log(this.roleback)
    })
  }
}
